import * as React from "react";
import { Autocomplete } from "src/common/components";

interface IOption {
  value: any;
  label: string;
}

interface IProps {
  defaultValues?: any[];
  label?: string;
  placeholder?: string;
  setFieldValue: (name: string, value: any) => void;
  onChange?: (newValues: any[]) => void;
  name: string;
  options: IOption[];
  singleSelection?: boolean;
  disabled?: boolean;
}

const AutocompleteFilter = ({
  defaultValues,
  name,
  setFieldValue,
  options,
  label,
  onChange,
  placeholder,
  singleSelection = false,
  disabled
}: IProps) => {
  const handleChange = React.useCallback(
    (newValues: any[]) => {
      setFieldValue(name, newValues);
      if (onChange) {
        onChange(newValues);
      }
    },
    [name, setFieldValue]
  );

  return (
    <Autocomplete
      defaultValues={defaultValues}
      label={label}
      placeholder={placeholder}
      onChange={handleChange}
      options={options}
      singleSelection={singleSelection}
      disabled={disabled}
    />
  );
};

export default AutocompleteFilter;
